export const ID = '7193bbb4-4fde-4444-8bd0-2f18d3212698';

export const NAME = 'Image';
